export default __webpack_public_path__ + "static/media/CNo.59-4.4a49a9bc.jpg";